import { render } from "./faqs.vue?vue&type=template&id=1443ca4e&scoped=true"
import script from "./faqs.vue?vue&type=script&lang=js"
export * from "./faqs.vue?vue&type=script&lang=js"

import "./faqs.vue?vue&type=style&index=0&id=1443ca4e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1443ca4e"]])

export default __exports__